import activityPanelStore from 'shared/store/activityPanelStore';
import constraintsStore from 'shared/store/constraintsStore';

/**
 * Wipe every UI indicator that surfaces "the agent changed this constraint":
 *   - per-field orange borders + per-section accordion red dots
 *     (driven by `constraintsStore.agentChangedPaths`)
 *   - "new constraints added" pulse
 *
 * The nav-level red dot on the Vincoli menu item is derived from the
 * same constraintsStore fields, so clearing `agentChangedPaths` below
 * turns it off automatically — no explicit toggle here.
 *
 * Call this from every code path that represents "the user has now
 * acknowledged / superseded all agent changes": Reset, applyProfile,
 * applyPredefiniti, the Manage Profiles dialog's apply/delete, and Invia.
 * NOT called from Save (Salva) — per spec, saving preserves the memory
 * of agent edits so the user can revisit them after the persistence step.
 */
export const clearAgentChangeIndicators = (): void => {
  activityPanelStore.setState({
    newConstraintsAdded: false,
  });
  constraintsStore.setState({
    agentChangedPaths: [],
    acknowledgedSectionGroups: [],
  });
};
